import { Button, Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	primaryLabel: string;
	onPrimary: () => void;
	primaryIcon?: ReactNode;
	isPrimaryLoading?: boolean;
	secondaryLabel: string;
	onSecondary: () => void;
	isSecondaryDisabled?: boolean;
};

export const FooterActions: FC<Props> = ({
	primaryLabel,
	onPrimary,
	primaryIcon,
	isPrimaryLoading,
	secondaryLabel,
	onSecondary,
	isSecondaryDisabled,
}) => {
	const theme = useTheme();

	return (
		<Stack
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.lg}
			gap={theme.spacingTokens.md}
		>
			<Button variant="primary" onClick={onPrimary} loading={isPrimaryLoading}>
				{primaryIcon}
				{primaryLabel}
			</Button>
			<Button
				variant="textLink"
				onClick={onSecondary}
				disabled={isSecondaryDisabled}
				fullWidth
				sx={{ py: theme.spacingTokens.sm }}
			>
				{secondaryLabel}
			</Button>
		</Stack>
	);
};
